import MonthEndAlertsService from '../../services/apiServices/monthEndAlert/monthEndALerts';
import React, { useEffect, useState, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
  Button,
} from '@mui/material';
import { AxiosResponse } from 'axios';
import moment from 'moment';

interface MEAPrintDialogProps {
  startDate: string;
  endDate: string;
  open: boolean;
  onClose: () => void;
}

interface MEAPrintPDFResponse {
  date: string;
  code: string;
  message: string;
  data: any | null;
  path: string;
  requestId: string;
  version: string;
}

const MEAPrintDialog: React.FC<MEAPrintDialogProps> = ({ startDate, endDate, open, onClose }) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPdf = useCallback(() => {
    setLoading(true);
    setError(null);

    MonthEndAlertsService.getMonthEndAlertsPdfUrl(startDate, endDate)
      .then((response: AxiosResponse<MEAPrintPDFResponse>) => {
        const responseData = response.data;
        if (responseData.code === 'OK' && responseData.message) {
          setPdfUrl(responseData.message);
        } else {
          setError('Failed to fetch PDF URL.');
        }
      })
      .catch(() => setError('An error occurred while fetching the PDF URL.'))
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  useEffect(() => {
    if (open) {
      fetchPdf();
    }
  }, [fetchPdf, open]);

  const returnFormattedDate = (date: string) => {
    const jsDate = moment(date, 'YYYY-MM-DD').toDate();
    return moment(jsDate).format('MMM D, YYYY');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        Closeout alerts {`(${returnFormattedDate(startDate)  + "- "+ returnFormattedDate(endDate)})`}
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            textAlign="center"
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            <Typography style={{ color: 'red', marginBottom: '16px' }}>{error}</Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={fetchPdf}
            >
              Retry
            </Button>
          </Box>
        ) : pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="Schedule PDF"
            style={{ width: '100%', height: '80vh', border: 'none' }}
          />
        ) : (
          <div>No PDF URL available.</div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MEAPrintDialog;
